/* BGalz Market (Shopify) — front-end behaviour, no dependencies. */
(function () {
	'use strict';

	var C = window.BZ || {};
	var T = C.i18n || {};
	var $ = function (s, r) { return (r || document).querySelector(s); };
	var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
	var store = {
		get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
		set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
	};
	function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
	function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
	function money(cents) {
		var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return (C.money || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, v.split('.')[0]);
	}
	function sized(url, w) {
		if (!url) { return ''; }
		if (url.indexOf('//') === 0) { url = 'https:' + url; }
		return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&height=' + w + '&crop=center';
	}
	var ICON = {
		heart: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3s-7.5-4.6-9.2-9.4C1.6 7.4 3.8 4 7.3 4c2 0 3.6 1.1 4.7 2.7C13.1 5.1 14.7 4 16.7 4c3.5 0 5.7 3.4 4.5 6.9-1.7 4.8-9.2 9.4-9.2 9.4z"/></svg>',
		plus: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
		minus: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
		check: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
		sliders: '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/></svg>'
	};

	/* Product card from a /products/<handle>.js payload, same markup as snippets/bz-card. */
	function cardHtml(p) {
		var off = p.compare_at_price > p.price ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
		var single = p.variants && p.variants.length === 1;
		var img = sized(p.featured_image, 600);
		var add = '';
		if (p.available && single) {
			add = '<button class="pc__add" type="button" data-add="' + p.variants[0].id + '">' + ICON.plus + '<span>' + esc(T.addToCart) + '</span></button>';
		} else if (p.available) {
			add = '<a class="pc__add" href="' + esc(p.url) + '">' + ICON.sliders + '<span>Choose options</span></a>';
		}
		var pill = !p.available ? '<span class="pill pill--muted">Sold out</span>' : (p.price >= (C.freeCents || 10000) ? '<span class="pill pill--ship">Free shipping</span>' : '');
		return '<article class="pc"><div class="pc__media"><a class="pc__link" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
			(img ? '<img class="pc__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
			'<button class="fav-btn" type="button" data-fav="' + esc(p.handle) + '" aria-pressed="false" aria-label="Save ' + esc(p.title) + ' to Favorites">' + ICON.heart + '</button>' + add +
			'</div><div class="pc__body"><h3 class="pc__title"><a href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(p.title) + '</a></h3>' +
			'<p class="pc__price">' + (p.price_varies ? '<span class="pc__from">From</span> ' : '') + '<b>' + esc(money(p.price)) + '</b>' +
			(off > 0 ? ' <del>' + esc(money(p.compare_at_price)) + '</del> <span class="pc__off">(' + off + '% off)</span>' : '') + '</p>' + pill + '</div></article>';
	}
	function fetchProducts(handles) {
		return Promise.all(handles.map(function (h) {
			return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
		})).then(function (rows) { return rows.filter(Boolean); });
	}

	/* ------------------------------------------------------------ toast */
	var toastEl = $('.toast'), toastTimer;
	function toast(html, ms) {
		if (!toastEl) { return; }
		toastEl.innerHTML = html;
		toastEl.hidden = false;
		toastEl.style.animation = 'none'; void toastEl.offsetWidth; toastEl.style.animation = '';
		clearTimeout(toastTimer);
		toastTimer = setTimeout(function () { toastEl.hidden = true; }, ms || 4200);
	}

	/* ------------------------------------------------------------ header */
	var hdr = $('[data-hdr]');
	if (hdr) {
		var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 40); };
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	}
	var catsBtn = $('[data-cats]'), catsPanel = $('#cats-panel');
	function closeCats() { if (catsPanel && !catsPanel.hidden) { catsPanel.hidden = true; catsBtn.setAttribute('aria-expanded', 'false'); } }
	if (catsBtn && catsPanel) {
		catsBtn.addEventListener('click', function (e) {
			e.stopPropagation();
			var open = catsPanel.hidden;
			catsPanel.hidden = !open;
			catsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
		document.addEventListener('click', function (e) { if (!catsPanel.contains(e.target)) { closeCats(); } });
	}

	/* Department row: show what fits, fold the rest into "More". Phones scroll instead. */
	$$('[data-prio]').forEach(function (root) {
		var list = $('[data-prio-list]', root), more = $('[data-prio-more]', root), btn = $('[data-prio-btn]', root), pop = $('[data-prio-pop]', root);
		if (!list || !more || !btn || !pop) { return; }
		var links = $$('a', list);
		function close() { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
		function layout() {
			links.forEach(function (l) { l.hidden = false; });
			close();
			if (window.innerWidth <= 900) { more.hidden = true; return; }
			more.hidden = false;
			var room = list.clientWidth, cut = [];
			links.forEach(function (l) { if (l.offsetLeft + l.offsetWidth > room + 1) { cut.push(l); } });
			if (!cut.length) { more.hidden = true; return; }
			cut.forEach(function (l) { l.hidden = true; });
			pop.innerHTML = cut.map(function (l) { return '<a href="' + esc(l.getAttribute('href')) + '"' + (l.getAttribute('aria-current') ? ' aria-current="page"' : '') + '>' + esc(l.textContent) + '</a>'; }).join('');
			btn.classList.toggle('is-current', cut.some(function (l) { return l.getAttribute('aria-current'); }));
		}
		btn.addEventListener('click', function (e) {
			e.stopPropagation();
			var open = pop.hidden;
			pop.hidden = !open;
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
		document.addEventListener('click', function (e) { if (!more.contains(e.target)) { close(); } });
		document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
		window.addEventListener('resize', debounce(layout, 120));
		if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layout); }
		layout();
	});

	function modal(el, open, opener) {
		if (!el) { return; }
		el.hidden = !open;
		document.documentElement.style.overflow = open ? 'hidden' : '';
		if (open) {
			el._opener = opener || document.activeElement;
			var f = el.querySelector('button, a, input');
			if (f) { setTimeout(function () { f.focus(); }, 30); }
		} else if (el._opener && el._opener.focus) {
			el._opener.focus();
		}
	}
	var drawer = $('#drawer'), filters = $('#filters');
	$$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { modal(drawer, true, b); }); });
	$$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { modal(drawer, false); }); });
	$$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { modal(filters, true, b); }); });
	$$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { modal(filters, false); }); });

	var lb = $('[data-lightbox]'), lbImg = lb && $('.lightbox__img', lb), lbIdx = 0;
	var gal = $('[data-gallery]');
	var slides = gal ? $$('.gal__slide[data-full]', gal) : [];
	function closeLightbox() { if (lb && !lb.hidden) { lb.hidden = true; document.documentElement.style.overflow = ''; } }

	document.addEventListener('keydown', function (e) {
		if (e.key !== 'Escape') { return; }
		closeCats();
		if (drawer && !drawer.hidden) { modal(drawer, false); }
		if (filters && !filters.hidden) { modal(filters, false); }
		closeLightbox();
		$$('.search__suggest').forEach(function (s) { s.hidden = true; });
	});

	/* ------------------------------------------------------------ search */
	$$('form[data-suggest]').forEach(function (form) {
		var input = $('.search__input', form), box = $('.search__suggest', form), idx = -1, last = '';
		if (!input || !box) { return; }
		var run = debounce(function () {
			var q = input.value.trim();
			if (q.length < 2) { box.hidden = true; return; }
			if (q === last) { box.hidden = false; return; }
			last = q;
			fetch((C.searchUrl || '/search') + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (input.value.trim() !== q) { return; }
					var items = (res && res.resources && res.resources.results && res.resources.results.products) || [];
					var all = (C.searchUrl || '/search') + '?type=product&q=' + encodeURIComponent(q);
					var html = items.length ? items.map(function (it) {
						var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
						var price = it.price ? money(Math.round(parseFloat(it.price) * 100)) : '';
						return '<a class="sugg" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(sized(img, 100)) + '" alt="" width="44" height="44">' : '') + '<span class="sugg__name">' + esc(it.title) + '</span><span class="sugg__price">' + esc(price) + '</span></a>';
					}).join('') : '<p class="sugg__empty">' + esc(T.noResults) + '</p>';
					html += '<a class="sugg sugg--all" href="' + esc(all) + '">' + esc(T.seeAll) + ' “' + esc(q) + '”</a>';
					box.innerHTML = html;
					box.hidden = false;
					idx = -1;
				})
				.catch(function () { box.hidden = true; });
		}, 220);
		input.addEventListener('input', run);
		input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; } });
		input.addEventListener('keydown', function (e) {
			var links = $$('.sugg', box);
			if (box.hidden || !links.length) { return; }
			if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				e.preventDefault();
				idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
				links.forEach(function (l, i) { l.classList.toggle('is-active', i === idx); });
			} else if (e.key === 'Enter' && idx > -1) {
				e.preventDefault();
				window.location = links[idx].href;
			}
		});
		document.addEventListener('click', function (e) { if (!form.contains(e.target)) { box.hidden = true; } });
	});

	/* --------------------------------------------------------- favorites */
	var FAV_KEY = 'bz_favs';
	function favs() { var f = store.get(FAV_KEY, []); return Array.isArray(f) ? f.filter(function (h) { return typeof h === 'string' && h; }) : []; }
	function paintFavs() {
		var list = favs();
		$$('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-fav')) > -1 ? 'true' : 'false'); });
		$$('.fav-count').forEach(function (c) { c.textContent = list.length; c.hidden = !list.length; });
	}
	function favEmpty() {
		var grid = $('[data-fav-grid]'), empty = $('[data-fav-empty]');
		if (grid && empty) { empty.hidden = grid.children.length > 0; }
	}
	document.addEventListener('click', function (e) {
		var b = e.target.closest('[data-fav]');
		if (!b) { return; }
		e.preventDefault();
		var h = b.getAttribute('data-fav'), list = favs(), at = list.indexOf(h);
		if (at > -1) { list.splice(at, 1); } else { list.unshift(h); }
		store.set(FAV_KEY, list.slice(0, 100));
		paintFavs();
		b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
		toast(ICON.heart + '<span>' + esc(at > -1 ? T.favRemove : T.favAdd) + '</span>' + (at > -1 ? '' : '<a href="' + esc(C.favUrl) + '">View</a>'), 2600);
		var grid = $('[data-fav-grid]');
		if (at > -1 && grid && grid.contains(b)) { var card = b.closest('.pc'); if (card) { card.remove(); } favEmpty(); }
	});
	paintFavs();
	window.addEventListener('storage', function (e) { if (e.key === FAV_KEY) { paintFavs(); } });

	var favGrid = $('[data-fav-grid]');
	if (favGrid) {
		var hs = favs();
		if (!hs.length) { favEmpty(); } else {
			fetchProducts(hs).then(function (rows) {
				favGrid.innerHTML = rows.map(cardHtml).join('');
				paintFavs();
				favEmpty();
			});
		}
	}

	/* ---------------------------------------------------- recently viewed */
	var SEEN_KEY = 'bz_seen';
	var listing = $('[data-product-handle]');
	if (listing) {
		var me = listing.getAttribute('data-product-handle');
		var seen = store.get(SEEN_KEY, []);
		if (!Array.isArray(seen)) { seen = []; }
		seen = [me].concat(seen.filter(function (h) { return h !== me; })).slice(0, 13);
		store.set(SEEN_KEY, seen);
	}
	$$('[data-seen]').forEach(function (sec) {
		var grid = $('[data-seen-grid]', sec), skip = sec.getAttribute('data-seen-skip');
		var list = store.get(SEEN_KEY, []);
		if (!Array.isArray(list) || !grid) { return; }
		list = list.filter(function (h) { return typeof h === 'string' && h && h !== skip; }).slice(0, 6);
		if (!list.length) { return; }
		fetchProducts(list).then(function (rows) {
			if (!rows.length) { return; }
			grid.innerHTML = rows.map(cardHtml).join('');
			sec.hidden = false;
			paintFavs();
		});
		var clear = $('[data-seen-clear]', sec);
		if (clear) { clear.addEventListener('click', function () { store.set(SEEN_KEY, skip ? [skip] : []); sec.hidden = true; }); }
	});

	/* -------------------------------------------------------- add to bag */
	function refreshCount() {
		return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
			$$('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
			return c;
		}).catch(function () { /* ignore */ });
	}
	function addToCart(id, qty, img) {
		return fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: [{ id: +id, quantity: +qty || 1 }] })
		}).then(function (r) {
			return r.json().then(function (j) { if (!r.ok) { var e = new Error('cart'); e.msg = j && (j.description || j.message); throw e; } return j; });
		}).then(function (res) {
			refreshCount().then(function (c) {
				var left = '';
				if (c && C.freeQty && C.freeCents) {
					var needQ = C.freeQty - c.item_count, needC = C.freeCents - c.total_price;
					left = (needQ <= 0 || needC <= 0) ? 'Free standard shipping unlocked' : 'Add ' + needQ + ' more ' + (needQ === 1 ? 'item' : 'items') + ' for free shipping';
				}
				toast((img ? '<img src="' + esc(img) + '" alt="">' : ICON.check) + '<span>' + esc(T.added) + (left ? '<small>' + esc(left) + '</small>' : '') + '</span><a href="' + esc(C.cartUrl || '/cart') + '">' + esc(T.viewCart) + '</a>', 5200);
			});
			return res;
		});
	}
	document.addEventListener('click', function (e) {
		var b = e.target.closest('button[data-add]');
		if (!b) { return; }
		e.preventDefault();
		var card = b.closest('.pc'), img = card && $('.pc__img', card);
		b.classList.add('is-busy');
		addToCart(b.getAttribute('data-add'), 1, img && (img.currentSrc || img.src))
			.catch(function (err) { toast('<span>' + esc((err && err.msg) || T.error) + '</span>'); })
			.then(function () { b.classList.remove('is-busy'); });
	});

	/* ------------------------------------------------------- qty steppers */
	function steppers(root) {
		$$('.quantity', root).forEach(function (q) {
			var input = $('input.qty', q);
			if (!input || q.dataset.step) { return; }
			q.dataset.step = '1';
			var minus = document.createElement('button'), plus = document.createElement('button');
			minus.type = plus.type = 'button';
			minus.className = plus.className = 'qty-step';
			minus.innerHTML = ICON.minus; plus.innerHTML = ICON.plus;
			minus.setAttribute('aria-label', 'Decrease quantity');
			plus.setAttribute('aria-label', 'Increase quantity');
			q.insertBefore(minus, input);
			q.appendChild(plus);
			function bump(d) {
				var min = parseFloat(input.min) || 0, max = parseFloat(input.max) || Infinity;
				input.value = Math.min(max, Math.max(min, (parseFloat(input.value) || 0) + d));
				input.dispatchEvent(new Event('change', { bubbles: true }));
			}
			minus.addEventListener('click', function () { bump(-1); });
			plus.addEventListener('click', function () { bump(1); });
		});
	}
	steppers(document);

	/* -------------------------------------------------------------- bag */
	var cartForm = $('[data-cart-form]');
	if (cartForm) {
		var submitCart = debounce(function () { cartForm.submit(); }, 700);
		cartForm.addEventListener('change', function (e) { if (e.target.matches('input.qty')) { submitCart(); } });
		var cApply = $('[data-coupon-apply]'), cInput = $('[data-coupon]');
		if (cApply && cInput) {
			var go = function () { var code = cInput.value.trim(); if (code) { window.location = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart'); } };
			cApply.addEventListener('click', go);
			cInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
		}
	}

	/* --------------------------------------------------------- collection */
	var sortSel = $('[data-sort]');
	if (sortSel) {
		sortSel.addEventListener('change', function () {
			var u = new URL(window.location.href);
			u.searchParams.set('sort_by', sortSel.value);
			u.searchParams.delete('page');
			window.location = u.toString();
		});
	}
	var fForm = $('[data-filter-form]');
	if (fForm) {
		$$('[data-price-cap]', fForm).forEach(function (b) {
			b.addEventListener('click', function () {
				var max = fForm.querySelector('input[name="filter.v.price.lte"]'), min = fForm.querySelector('input[name="filter.v.price.gte"]');
				if (max) { max.value = b.getAttribute('data-price-cap'); }
				if (min) { min.value = ''; }
				fForm.submit();
			});
		});
		fForm.addEventListener('submit', function () {
			// Drop empty fields so the URL stays clean (and indexable rules stay simple).
			$$('input', fForm).forEach(function (i) { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') { i.disabled = true; } });
		});
	}

	/* ----------------------------------------------------------- listing */
	var galGo = null;
	function showLb(i) {
		if (!lb || !slides.length) { return; }
		lbIdx = (i + slides.length) % slides.length;
		lbImg.src = slides[lbIdx].getAttribute('data-full');
		lbImg.alt = ($('img', slides[lbIdx]) || {}).alt || '';
		lb.hidden = false;
		document.documentElement.style.overflow = 'hidden';
	}
	if (gal && slides.length) {
		var track = $('.gal__track', gal), thumbs = $$('.gal__thumb', gal), count = $('.gal__count b', gal), cur = 0;
		galGo = function (i, smooth) {
			cur = (i + slides.length) % slides.length;
			track.scrollTo({ left: track.clientWidth * cur, behavior: smooth === false ? 'auto' : 'smooth' });
		};
		var mark = function (i) {
			cur = i;
			thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
			if (count) { count.textContent = i + 1; }
			if (thumbs[i]) {
				var rail = thumbs[i].parentNode;
				if (rail.scrollHeight > rail.clientHeight) { rail.scrollTo({ top: thumbs[i].offsetTop - rail.clientHeight / 2 + 32, behavior: 'smooth' }); }
				if (rail.scrollWidth > rail.clientWidth) { rail.scrollTo({ left: thumbs[i].offsetLeft - rail.clientWidth / 2 + 28, behavior: 'smooth' }); }
			}
		};
		thumbs.forEach(function (t) { t.addEventListener('click', function () { galGo(+t.getAttribute('data-go')); }); });
		$$('[data-step]', gal).forEach(function (b) { b.addEventListener('click', function () { galGo(cur + (+b.getAttribute('data-step'))); }); });
		track.addEventListener('scroll', debounce(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60), { passive: true });
		track.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowRight') { e.preventDefault(); galGo(cur + 1); }
			if (e.key === 'ArrowLeft') { e.preventDefault(); galGo(cur - 1); }
		});
		slides.forEach(function (s, i) { s.addEventListener('click', function () { showLb(i); }); });
		var zoom = $('[data-zoom]', gal);
		if (zoom) { zoom.addEventListener('click', function () { showLb(cur); }); }
		window.addEventListener('resize', debounce(function () { galGo(cur, false); }, 120));
	}
	if (lb) {
		$$('[data-lb-step]', lb).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbIdx + (+b.getAttribute('data-lb-step'))); }); });
		$('[data-lightbox-close]', lb).addEventListener('click', closeLightbox);
		lb.addEventListener('click', function (e) { if (e.target === lb) { closeLightbox(); } });
		document.addEventListener('keydown', function (e) {
			if (lb.hidden) { return; }
			if (e.key === 'ArrowRight') { showLb(lbIdx + 1); }
			if (e.key === 'ArrowLeft') { showLb(lbIdx - 1); }
		});
	}

	/* Variant picker: radios per option -> matching variant -> form, price, stock, photo, URL. */
	var vpick = $('[data-vpick]'), vdata = $('script[data-variants]');
	if (vpick && vdata) {
		var variants = [];
		try { variants = JSON.parse(vdata.textContent); } catch (e) { variants = []; }
		var idInput = $('[data-variant-id]'), addBtn = $('[data-add-btn]'), addLabel = $('[data-add-label]'), buyNow = $('[data-buy-now]');
		var priceEl = $('[data-price]'), wasEl = $('[data-was]'), offEl = $('[data-off]'), offPill = $('[data-off-pill]');
		var skuEl = $('[data-sku]'), barEl = $('[data-barcode]'), stockEl = $('[data-stock]'), noneEl = $('[data-vpick-none]');
		var barPrice = $('[data-price-bar]'), barBtn = $('[data-buybar-add]');
		var chosen = function () {
			var sel = [];
			$$('input[data-opt]:checked', vpick).forEach(function (i) { sel[+i.getAttribute('data-opt')] = i.value; });
			return sel;
		};
		var match = function (sel) {
			for (var i = 0; i < variants.length; i++) {
				var ok = true;
				for (var k = 0; k < sel.length; k++) { if (sel[k] != null && variants[i].options[k] !== sel[k]) { ok = false; break; } }
				if (ok) { return variants[i]; }
			}
			return null;
		};
		var repaint = function (sel) {
			$$('input[data-opt]', vpick).forEach(function (input) {
				var pos = +input.getAttribute('data-opt');
				var any = variants.some(function (vr) {
					if (!vr.available || vr.options[pos] !== input.value) { return false; }
					for (var k = 0; k < sel.length; k++) { if (k !== pos && sel[k] != null && vr.options[k] !== sel[k]) { return false; } }
					return true;
				});
				input.parentNode.classList.toggle('is-off', !any);
			});
		};
		var setBuy = function (ok, label) {
			[addBtn, buyNow, barBtn].forEach(function (b) { if (b) { b.disabled = !ok; } });
			if (addLabel) { addLabel.textContent = label; }
		};
		var apply = function () {
			var sel = chosen(), vr = match(sel);
			repaint(sel);
			$$('[data-vpick-cur]', vpick).forEach(function (b) { var i = +b.getAttribute('data-vpick-cur'); if (sel[i]) { b.textContent = sel[i]; } });
			if (!vr) { if (noneEl) { noneEl.hidden = false; } setBuy(false, 'Unavailable'); return; }
			if (noneEl) { noneEl.hidden = true; }
			if (idInput) { idInput.value = vr.id; }
			setBuy(vr.available, vr.available ? T.addToCart : 'Sold out');
			if (priceEl) { priceEl.textContent = vr.price; }
			if (barPrice) { barPrice.textContent = vr.price; }
			if (wasEl) { wasEl.hidden = !vr.compare; if (vr.compare) { wasEl.textContent = vr.compare; } }
			if (offEl) { offEl.hidden = !vr.off; offEl.textContent = '(' + vr.off + '% off)'; }
			if (offPill) { offPill.hidden = !vr.off; offPill.textContent = vr.off + '% off'; }
			if (skuEl) { skuEl.textContent = vr.sku || '—'; }
			if (barEl) { barEl.textContent = vr.barcode || 'None, sold unbranded under our stock code'; }
			if (stockEl) { stockEl.textContent = vr.available ? 'In stock' : 'Sold out'; stockEl.classList.toggle('is-in', vr.available); }
			if (vr.media && galGo) {
				var at = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(vr.media); });
				if (at > -1) { galGo(at); }
			}
			if (window.history && history.replaceState) {
				var u = new URL(window.location.href);
				u.searchParams.set('variant', vr.id);
				history.replaceState(history.state, '', u.toString());
			}
		};
		vpick.addEventListener('change', function (e) { if (e.target.matches('input[data-opt]')) { apply(); } });
		repaint(chosen());
	}

	var form = $('form[data-bz-form]');
	if (form) {
		form.addEventListener('submit', function (e) {
			var sub = e.submitter;
			if (!sub || sub.name !== 'add') { return; } // "Buy it now" posts normally with return_to=/checkout
			e.preventDefault();
			var id = (form.querySelector('[name="id"]') || {}).value, qty = (form.querySelector('[name="quantity"]') || {}).value;
			var first = $('.gal__slide img');
			sub.classList.add('is-busy');
			addToCart(id, qty, first && (first.currentSrc || first.src))
				.catch(function (err) { toast('<span>' + esc((err && err.msg) || T.error) + '</span>'); })
				.then(function () { sub.classList.remove('is-busy'); });
		});
		var bar = $('[data-buybar]');
		if (bar) {
			var sync = function () {
				var r = form.getBoundingClientRect();
				var show = r.bottom < 0 && window.innerWidth <= 900;
				bar.hidden = !show;
				document.body.classList.toggle('has-buybar', show);
			};
			window.addEventListener('scroll', sync, { passive: true });
			sync();
			var barBtn2 = $('[data-buybar-add]', bar);
			if (barBtn2) { barBtn2.addEventListener('click', function () { var btn = form.querySelector('[name="add"]'); if (btn) { btn.click(); } }); }
		}
	}

	// Arrival windows in business days (handling + transit), set per service in data-min / data-max.
	var arrive = $$('[data-arrive]');
	if (arrive.length) {
		var addBiz = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) { n--; } } return d; };
		var mon = function (d) { return d.toLocaleDateString('en-US', { month: 'short' }); };
		arrive.forEach(function (el) {
			var lo = parseInt(el.getAttribute('data-min'), 10), hi = parseInt(el.getAttribute('data-max'), 10);
			if (!lo || !hi) { return; }
			var a = addBiz(lo), b = addBiz(hi);
			el.textContent = mon(a) + ' ' + a.getDate() + '–' + (mon(a) === mon(b) ? '' : mon(b) + ' ') + b.getDate();
		});
	}

	$$('[data-clamp]').forEach(function (c) {
		var body = $('.clamp__body', c), more = $('.clamp__more', c);
		if (!body || !more) { return; }
		var check = function () { var over = body.scrollHeight > body.clientHeight + 4; c.classList.toggle('is-clamped', over); more.hidden = !over; };
		var det = c.closest('details');
		if (det) { det.addEventListener('toggle', check); }
		check();
		more.addEventListener('click', function () { c.classList.add('is-open'); c.classList.remove('is-clamped'); more.hidden = true; });
	});

	/* -------------------------------------------------------------- rails */
	$$('[data-rail]').forEach(function (rail) {
		var track = $('.rail__track', rail), prev = $('.rail__btn--prev', rail), next = $('.rail__btn--next', rail);
		if (!track) { return; }
		var sync = function () {
			if (prev) { prev.disabled = track.scrollLeft < 8; }
			if (next) { next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
		};
		[prev, next].forEach(function (b) {
			if (b) { b.addEventListener('click', function () { track.scrollBy({ left: (+b.getAttribute('data-dir')) * track.clientWidth * 0.9, behavior: 'smooth' }); }); }
		});
		track.addEventListener('scroll', debounce(sync, 50), { passive: true });
		sync();
	});
})();
